// F-053: standard building-safety responsibilities. Choosing one fills the title; the controlled code is derived, never typed.
export const standardResponsibilities=['Accountable person','Principal accountable person','Building safety manager','Fire safety','Structural safety','Golden thread information','Resident engagement','Mandatory occurrence reporting','Contractor and competence management'] as const;
/** Controlled code for a responsibility title: upper-case words joined by underscores, at most 80 characters. */
export function responsibilityCode(title:string){
  const code=title.trim().toUpperCase().replace(/[^A-Z0-9]+/g,'_').replace(/^_+|_+$/g,'').slice(0,80);
  return code.length>=2?code:'RESPONSIBILITY';
}
/** F-054: the delegator is the party already holding the responsibility, when that party can be identified unambiguously. */
export function delegatorFor(holderName:string|undefined,parties:Array<{party_kind:string;id:string;name:string}>){
  const matches=parties.filter(p=>p.name===holderName);
  return matches.length===1?`${matches[0]!.party_kind}:${matches[0]!.id}`:'';
}
/** F-058: a profile review inherits the profile scope instead of asking for it again. */
export const reviewScopeFor=(profile?:{scope_summary?:string})=>(profile?.scope_summary?.trim()||'Profile scope').slice(0,2000);
/** F-059: one field carries the matter and the advice needed; the title is its first line, shortened. */
export function escalationTitle(matter:string){
  const first=matter.trim().split(/\r?\n/)[0]??'';
  return (first.length>120?`${first.slice(0,117).trimEnd()}...`:first).padEnd(3,'.');
}
